import { createContext, useContext, useState, useRef } from "react";

const SnackbarContext = createContext(null);

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });
  const timeoutRef = useRef(null); // ✅ Store timeout reference

  const showSnackbar = (message) => {
    // ✅ Clear any existing timeout before setting a new one
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setSnackbar({ open: true, message });

    // ✅ Set new timeout and store its ID
    timeoutRef.current = setTimeout(() => {
      setSnackbar({ open: false, message: "" });
      timeoutRef.current = null; // Reset ref after timeout completes
    }, 4000);
  };

  return (
    <SnackbarContext.Provider value={{ snackbar, showSnackbar }}>
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  }
  return context;
};
